module.exports = __webpack_public_path__ + "img/Selo-Melhor-Velocidade.6bd8e1f7.svg";